import { jwtDecode } from 'jwt-decode';

import { apiSensedia } from '../services/api-sensedia';
import { isJson } from './isJson.util';

export type UserDataType = {
  name: string;
  producerCode: string;
  cpfCnpjType: string;
  codeNac: string;
  isManager: boolean;
  isAdvice: boolean;
  sellerWithElevateAccess: boolean;
  seller: {
    user_id: string;
    codigo_produtor: string;
    redirects_to: {
      path: string;
    };
  };
  iat: number;
  exp: number;
  jti: string;
};

export const getNewDadosLogin: () => Promise<UserDataType> = async () => {
  const res = await apiSensedia.get('/usuarios/dados-login');

  const decodedJwt = jwtDecode(res.data.user_data_token) as UserDataType;

  localStorage.setItem('dados-login', JSON.stringify(decodedJwt));
  localStorage.setItem('user-data-token', res.data.user_data_token);

  console.log('dados login token refreshed');

  return decodedJwt;
};

export const getDadosLogin = async ({
  newLogin = false
}: {
  newLogin?: boolean;
} = {}): Promise<UserDataType> => {
  console.log('chamou getDadosLogin');
  if (newLogin) return await getNewDadosLogin();

  const dadosLoginString = localStorage.getItem('dados-login');

  if (!dadosLoginString || !isJson(dadosLoginString)) {
    const userData = await getNewDadosLogin();
    return userData;
  }

  let dadosLogin: UserDataType = JSON.parse(dadosLoginString);

  const expiry = dadosLogin.exp * 1000;
  const issuedAt = dadosLogin.iat * 1000;

  const jwtTtl = expiry - issuedAt;

  const currentDate = new Date().getTime();
  const expiryMinusHalfTttl = expiry - jwtTtl / 2;

  if (currentDate > expiryMinusHalfTttl) {
    const userData = await getNewDadosLogin();
    dadosLogin = userData;
  }

  return dadosLogin;
};

export const isDadosLoginTokenValid = () => {
  const dadosLoginString = localStorage.getItem('dados-login');

  if (!dadosLoginString || !isJson(dadosLoginString)) return false;

  const dadosLogin: UserDataType = JSON.parse(dadosLoginString);

  const expiry = dadosLogin?.exp * 1000;
  const issuedAt = dadosLogin?.iat * 1000;

  const jwtTtl = expiry - issuedAt;

  const currentDate = new Date().getTime();
  const expiryMinusHalfTttl = expiry - jwtTtl / 2;

  return currentDate <= expiryMinusHalfTttl;
};
